import { type Session } from '@halo/chat-sdk-react';
import { Text } from '@chakra-ui/react';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgGroupMediaCloseContentProps } from './msg-group-media-close-content';
import { MsgGroupMediaCloseContent } from './msg-group-media-close-content';

export interface MsgGroupMediaCloseProps extends MsgGroupMediaCloseContentProps {
  session: Session;
}

export const MsgGroupMediaClose = memo(function MsgGroupMediaClose({
  message,
  session,
}: MsgGroupMediaCloseProps) {
  const { user_count } = message.payload;
  const { t } = useTranslation();

  return (
    <MsgMediaCard message={message} session={session}>
      <MsgMediaCardContent
        message={message}
        session={session}
        title={t('calls.callClosedTitle')}
        description={
          <MsgGroupMediaCloseContent message={message}>
            {({ duration }) => (
              <Text>{t('calls.callClosed', { duration: duration, count: user_count })}</Text>
            )}
          </MsgGroupMediaCloseContent>
        }
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
